<template>
	<button
		data-component="google-auth-button"
		:data-size="size"
		:disabled="getButtonDisabled"
		@click="handleClick"
	>
		<icon icon="v2-google-icon" colour="transparent" />
		<span data-element="button-text">
			<slot>Sign in with Google</slot>
		</span>
	</button>
</template>

<script>

	import Icon from '@/components/ui/Icon';

	export default {
		components: {
			Icon
		},
		mixins: [],
		props: {
			disabled: {
				type: Boolean,
				default: false
			},
			uxMode: {
				type: String,
				validator (value) {
					return [
						'popup',
						'redirect'
					].includes(value);
				},
				default: 'popup'
			},
			size: {
				type: String,
				validator (value) {
					return [
						'md',
						'sm'
					].includes(value);
				},
				default: 'md'
			}
		},
		data: () => ({
			loading: false
		}),
		computed: {
			getIsReady () {
				return this.$gsiClientLoaded;
			},
			getButtonDisabled () {
				return this.disabled || this.loading || !this.getIsReady;
			}
		},
		methods: {
			handleClick () {
				this.$initGoogleCodeClient()
					.then((response) => {
						this.$emit('onSuccess', response);
					})
					.catch(error => {
						this.$store.commit('ui/showNotification', {
							notification: error.message
						});
						this.$emit('onError', error);
					});
			}
		}
	};

</script>

<style lang="scss" scoped>
	[data-component="google-auth-button"] {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		outline: none;
		border: 1px solid $c-brand-grey-lighter-7;
		border-radius: 5px;
		background-color: $c-white;

		&:not(:disabled) {
			cursor: pointer;
		}

		&:disabled {
			pointer-events: none;
			opacity: 0.6;
		}

		&:hover,
		&:focus {
			border: 1px solid $c-brand-grey-lighter-2;
		}

		&[data-size="md"] {
			height: rem(40);
			padding: 0 rem(10);
		}

		&[data-size="sm"] {
			padding: 0;
			height: rem(28);
		}

		[data-element="button-text"] {
			font-size: rem(18);
			line-height: 32px;
			color: $c-brand-black;
			margin-left: 8px;
		}
	}
</style>
